import { axios } from "../../config/axios";

export const currentMerchantAPI = {
  /**
   * Retrieve program settings
   * @returns {object}
   */
  GETProgramSettings() {
    const fields = ['bonus_rules', 'program_type', 'points_per_visit', 'points_per_dollar', 'loyalty', 'points_expiration_type', 'points_expiration_interval', 'points_cash_conversion_enabled', 'dollars_per_point'].join(',');
    return axios.get('/api/v3/current_merchant/info', {
      params: {
        fields
      }
    }).then(resp => resp.data);
  },
   /**
    * Retrieve cash per point settings
    * @returns {object} {dollars_per_point: 0.01, dollars_per_point_enabled: true, reward_pos_string: ""}
    */
  GETCashPerPointsSettings(...fields) {
    fields = ['dollars_per_point', 'springpay_enabled', 'reward_pos_string'].concat(fields).join(',');

    return axios.get('/api/v3/current_merchant/info', {
      params: {
        fields
      }
    }).then(resp => resp.data);
  },
  /**
   * Retrieve all current merchant notification images
   * filtered by category and subcategory (optional)
   * @param {string} category
   * @param {string} subcategory
   * @returns {object} {shared_image: [], merchant_images: []}
   */
  getNotificationImages(category, subcategory = null) {
    let params = {
      category: category
    }

    if(subcategory) params = { ...params, subcategory: subcategory }

    return axios.get("/api/v3/current_merchant/notification_images", { params })
                .then(resp => resp.data)
  },
  /**
   * Sets a merchant's spence api key
   * @param {string} id
   * @param {object} data
   * @returns {object} {}
   */
  PATCHSpenceApiKey(id, data) {
    return axios.patch(`/api/v3/current_merchant/set_spence_api_key`, data)
      .then(resp => true)
      .catch(err => false)
  },
  /**
   * Sets a merchant's merrco client id and client secret
   * @param {object} { client_id: "123", client_secret: "xyz" }
   * @returns {object} {}
   */
  PATCHMerrcoCredentials(credentials) {
    return axios.patch(`/api/v3/current_merchant/set_merrco_credentials`, credentials)
      .then(resp => true)
      .catch(err => false)
  },
  /**
  * Updates a merchant's campaign caddie options
  * @param {object} data { caddie_options: { selected_kpis: [] } }
  * @returns {object} { caddie_options: { available_kpis: [], selected_kpis: [] } }
  */
  PATCHCaddieOptions(data) {
    return axios.patch(`/api/v3/current_merchant/caddie_options`, data);
  },
  /**
   * @param {string} id
   * @param {object} data { current_merchant: {} }
   * @returns {object}
   */
  PUTProgramSettings(id, data) {
    return axios.put(`/api/v3/current_merchant/${id}`, data);
  }
}
